import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  lang: string;

  constructor(private base: BaseService) {}

  ngOnInit() {
    this.lang = this.base.getLang();
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }
}
